module.exports = __webpack_public_path__ + "static/media/share.698e8bc9.mp3";